import {
  GET_CLIENTES_REQUEST,
  GET_CLIENTES_SUCCESS,
  RESET_CLIENTES,
} from '../../actions/constants/clientes/clientes.constants';

const initialState = {
  loading: false,
  listado: [],
  total: 0,
  page: 1,
  start: 0,
  limit: 25,
  sede: null,
  archivado: false,
  tipoListado: 'listar',
  clientesSeleccionados: [],
};

export default function clientesReducer(state = initialState, { type, payload }) {
  switch (type) {
    case GET_CLIENTES_REQUEST: {
      return {
        ...state, loading: true,
      };
    }

    case GET_CLIENTES_SUCCESS: {
      const {
        datos, total, page, start, limit,
      } = payload;
      const { listado } = state;
      return {
        ...state, listado: [...listado, ...datos], total, loading: false, page, start, limit,
      };
    }

    case RESET_CLIENTES: {
      return {
        ...state, page: 1, start: 0, total: 25, listado: [],
      };
    }

    default:
      return state;
  }
}
